import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import AddNewTournament from "../pages/dashboardPage/tournamentSettings/addNewTournament/AddNewTournament";
import AllTournaments from "../pages/dashboardPage/tournamentSettings/allTournaments/AllTournaments";
import EditTournament from "../pages/dashboardPage/tournamentSettings/editTournament/EditTournament";
import SearchForTournament from "../pages/dashboardPage/tournamentSettings/searchForTournament/SearchForTournament";
import TournamentAccess from "../pages/dashboardPage/tournamentSettings/tournamentAccess/TournamentAccess";
import TournamentImages from "../pages/dashboardPage/tournamentSettings/tournamentImages/TournamentImages";

const TournamentNavigator = () => {
  const { rolePermissions } = useSelector((state) => state.user);

  return (
    <Routes>
      {rolePermissions.includes("view-tournaments") && (
        <Route path="/show-all-tournaments" element={<AllTournaments />} />
      )}
      {rolePermissions.includes("control-images") && (
        <Route path="/edit-tournaments-images" element={<TournamentImages />} />
      )}
      {rolePermissions.includes("create-tournaments") && (
        <Route path="/add-new-tournament" element={<AddNewTournament />} />
      )}
      {rolePermissions.includes("update-tournaments") && (
        <Route path="/edit-tournament" element={<EditTournament />} />
      )}
      {rolePermissions.includes("view-tournaments") && (
        <Route
          path="/search-one-tournament"
          element={<SearchForTournament />}
        />
      )}
      {rolePermissions.includes("control-tournament-access") && (
        <Route
          path="/control-tournaments-access"
          element={<TournamentAccess />}
        />
      )}
      {rolePermissions.includes("view-tournaments") && (
        <Route path="*" element={<AllTournaments />} />
      )}
    </Routes>
  );
};

export default TournamentNavigator;
